import React from "react";
import Site2Layout from "./Site2Layout";

const ACTIVITIES = [
  "Radiography machines",
  "Welding consumables",
  "Metal fabrication",
  "Steel grinding media",
  "Dry wall cutting machines",
  "High nickel alloys",
];

const Site2Activity = () => (
  <Site2Layout
    tag="Our Team & Work"
    title="Our Team & Activities"
    subtitle="The people and the projects that define Tarak Global Enterprises."
  >
    {/* CEO Section */}
    <section style={{ backgroundColor: "#ffffff" }} className="py-20 px-6">
      <div className="max-w-5xl mx-auto">
        <div
          style={{ background: "#f9fafb", border: "1px solid rgba(72, 31, 87, 0.12)" }}
          className="rounded-2xl overflow-hidden flex flex-col md:flex-row text-left shadow-sm"
        >
          <img
            src="https://res.cloudinary.com/dxity6o7b/image/upload/v1683140262/JSW_tpmgqe.jpg"
            alt="Our Team"
            className="w-full md:w-72 h-60 md:h-auto object-cover flex-shrink-0"
          />
          <div className="p-8 flex flex-col justify-center">
            <span
              style={{ color: "#481F57", borderColor: "rgba(72, 31, 87, 0.4)" }}
              className="text-xs font-bold tracking-widest uppercase border rounded-full px-3 py-1 mb-4 inline-block w-fit"
            >
              Leadership
            </span>
            <h2 style={{ color: "#481F57" }} className="text-2xl font-extrabold mb-3">
              Our Team
            </h2>
            <div style={{ backgroundColor: "#481F57", width: "40px", height: "3px" }} className="mb-5 rounded" />
            <p className="text-gray-700 text-base leading-8">
              Our CEO has four decades of leadership experience in various industries including
              ship building, welding machines, welding consumables, alloy castings, and
              fabrication. A metallurgical engineer with post graduation in management, he has
              completed a global strategic management program and attended many international
              business summits.
            </p>
            <p className="text-gray-700 text-base leading-8 mt-4">
              He brings extensive international business exposure acquired through work experience
              in the Middle East, China, USA, and many countries across Africa and Europe. He is
              supported by a committed team of marketing and technical professionals, and a pool
              of skilled freelancers selected based on specific project requirements.
            </p>
          </div>
        </div>
      </div>
    </section>

    {/* Activities Section */}
    <section
      style={{ backgroundColor: "#f9fafb", borderTop: "1px solid rgba(72, 31, 87, 0.08)" }}
      className="py-20 px-6"
    >
      <div className="max-w-5xl mx-auto">
        <div
          style={{ background: "#ffffff", border: "1px solid rgba(72, 31, 87, 0.12)" }}
          className="rounded-2xl overflow-hidden flex flex-col md:flex-row-reverse text-left shadow-sm"
        >
          <img
            src="https://res.cloudinary.com/dxity6o7b/image/upload/v1681489276/3_j3puzc.jpg"
            alt="Summary of Activities"
            className="w-full md:w-72 h-60 md:h-auto object-cover flex-shrink-0"
          />
          <div className="p-8 flex flex-col justify-center">
            <span
              style={{ color: "#481F57", borderColor: "rgba(72, 31, 87, 0.4)" }}
              className="text-xs font-bold tracking-widest uppercase border rounded-full px-3 py-1 mb-4 inline-block w-fit"
            >
              Track Record
            </span>
            <h2 style={{ color: "#481F57" }} className="text-2xl font-extrabold mb-3">
              Summary of Activities
            </h2>
            <div style={{ backgroundColor: "#481F57", width: "40px", height: "3px" }} className="mb-5 rounded" />
            <p className="text-gray-700 text-base leading-8 mb-6">
              We have successfully handled projects across a wide range of industrial domains:
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {ACTIVITIES.map((a, i) => (
                <div key={i} className="flex items-center gap-3">
                  <span style={{ color: "#481F57" }}>◈</span>
                  <span className="text-gray-800 text-sm font-semibold">{a}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  </Site2Layout>
);

export default Site2Activity;
